import { type MouseEvent as ReactMouseEvent } from 'react';

import { isLinkAction } from '../../../../core/components/series-action/utils/is-link-action.js';
import { useSetState } from '../../../hooks/store/selectors.js';

/**
 * Hook responsible to return the handler called when clicking on a category action.
 * The handler will handle the logic of keeping the tooltip open in case there are
 * multiple entries in the tooltip, hiding the tooltip alternatively.
 * @param hasMultipleItems -
 */
export const useSeriesActionClickHandler = (hasMultipleItems: boolean) => {
  const setState = useSetState();

  const multiItemsActionClickHandler = (e: ReactMouseEvent) => {
    if (!isLinkAction(e.target as HTMLElement)) {
      e.preventDefault();
    }
    // needed to avoid the propagation of the event that in some cases
    // introduce unexpected behaviors (e.g. unpinning tooltip)
    e.stopPropagation();
  };

  const singleItemActionClickHandler = (e: ReactMouseEvent) => {
    setState((prev) => ({
      ...prev,
      overlays: { ...prev.overlays, visibleTooltip: false },
    }));
  };

  return hasMultipleItems
    ? multiItemsActionClickHandler
    : singleItemActionClickHandler;
};
